import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SendAssessmentComponent } from './send-assessment.component';
import { SendAssessmentResultsModalComponent } from './send-assessment-results-modal/send-assessment-results-modal.component';
import { FormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { ExternalNotesModule } from '../../external-notes/external-notes.module';
import { ModalModule, TypeaheadModule } from 'ngx-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AiAssistantModule } from '../../ai-assistant/ai-assistant.module';

@NgModule({
  declarations: [SendAssessmentComponent, SendAssessmentResultsModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    ExternalNotesModule,
    TypeaheadModule.forRoot(),
    NgSelectModule,
    AiAssistantModule,
    ModalModule.forRoot(),
  ],
  exports: [SendAssessmentComponent, SendAssessmentResultsModalComponent],
  entryComponents: [SendAssessmentComponent, SendAssessmentResultsModalComponent]
})
export class SendAssessmentModule { }
